export default __webpack_public_path__ + "static/media/augmenter.5d66d432.svg";